/**
 * herd
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: 0.220.0-SNAPSHOT
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { Attribute } from './attribute';


export interface StorageCreateRequest { 
    /**
     * Name of Storage
     */
    name: string;
    /**
     * Name of Storage Platform (eg S3) associated with this Storage
     */
    storagePlatformName: string;
    /**
     * Collection of name-value pairs. This can be used to store things such as S3 bucket names, validation flags, and custom                   user-defined meta-data about this storage                
     */
    attributes?: Array<Attribute>;
}
